window.LSGCollectionsFilter = undefined;

window.LSGSetCollections = () => {
  const search = window.location.search;
  const urlParams = new URLSearchParams(search);
  let collections = urlParams.get('collections')?.split(',');
  if (window.LSGCollectionsFilter != undefined) {
    collections = window.LSGCollectionsFilter.split(',');
  }
  collections?.forEach(el => {
    document.querySelectorAll(`.js-lsg-filters-item-collection[data-handle="${el}"]`).forEach(item => {
      item.classList.add('is-active')
    });
  });
  window.getCollectionURL(search);
}

window.LSGSortBy = async (value) => {
  const pathname = window.location.pathname;
  const search = window.location.search;
  const urlParams = new URLSearchParams(search);
  urlParams.set('sort_by', value);
  window.updatePage(`${pathname}?${urlParams.toString()}`);
}

function getCollectionURL(url) {
  const pathname = window.location.pathname;
  const urlParams = new URLSearchParams(url);
  const list = document.querySelectorAll(`.js-lsg-filters-item-collection.is-active`);
  let collections = [];
  const filterResults = document.querySelector('.js-lsg-collection-result-filter');
  filterResults?.querySelectorAll(".lsg-filters__result-filter-item--collection").forEach(el => {
    el.remove()
  })

  if (list.length > 0) {
    document.querySelectorAll('.js-lsg-collection-subitems').forEach(el => {
      el.classList.add('is-hidden');
    });
    list.forEach(el => {
      document.querySelectorAll(`.js-lsg-collection-subitems[data-handle="${el.getAttribute('data-handle')}"]`).forEach(el => {
        el.classList.remove('is-hidden');
        collections.push(el.getAttribute('data-handle'));
      });
      if (filterResults != null) {
        let btn = document.createElement("button");
        btn.setAttribute("x-on:click", el.getAttribute("x-on:click"));
        btn.setAttribute("data-handle", el.getAttribute("data-handle"));
        btn.innerText = el.getAttribute("data-ttl");
        btn.classList.add("is-active");
        btn.classList.add("lsg-filters__result-filter-item");
        btn.classList.add("lsg-filters__result-filter-item--collection");
        filterResults.append(btn);
      }
    });
    urlParams.set('collections', collections.toString());
    window.LSGCollectionsFilter = collections.toString();


  } else {
    document.querySelectorAll('.js-lsg-collection-subitems').forEach(el => {
      el.classList.remove('is-hidden');
    });

    urlParams.delete('collections');
    window.LSGCollectionsFilter = undefined;
  }
  if (filterResults != null) {
    if (filterResults.querySelectorAll('button').length > 1) {
      filterResults.classList.remove('is-hidden');
    } else {
      filterResults.classList.add('is-hidden');
    }
  }
  return `${pathname}?${urlParams.toString()}`;
}

window.LSGSortByCollection = async (value, item) => {
  document.querySelector(`.js-lsg-filters-item-collection[data-handle='${value}']`)?.classList.toggle('is-active');
  const url = getCollectionURL(window.location.search);
  history.replaceState({}, "", url);
}

window.LSGClearAll = () => {
  const pathname = window.location.pathname;
  const search = window.location.search;
  const urlParams = new URLSearchParams(search);
  urlParams.delete('collections');
  urlParams.delete('sort_by');
  urlParams.delete('filter.p.m.filters.benefits');
  window.LSGCollectionsFilter = undefined;
  window.updatePage(`${pathname}?${urlParams.toString()}`);
}
document.addEventListener('DOMContentLoaded', () => {
  window.LSGSetCollections();
}, false);

window.LSGToggleFilter = (target) => {
  let el = target;
  if (!el.classList.contains('lsg-filters__ttl')) {
    el = target.closest('.lsg-filters__ttl');
  }
  el.classList.toggle('is-closed')
}

window.LSGToggleFilterModal = (isShow) => {
  if (isShow) {
    document.querySelector('body').classList.add('is-show-filters')
  } else {
    document.querySelector('body').classList.remove('is-show-filters')
  }
}

window.LSGToggleSortModal = (isShow) => {
  if (isShow) {
    document.querySelector('body').classList.add('is-show-sort')
  } else {
    document.querySelector('body').classList.remove('is-show-sort')
  }
}
